export default {
  notAvailable: 'N/A'
}
